
const formRoutes = {
  name: 'dominaForms',
  component: () => import('modules/dominaForm/layouts/FormLayout.vue'),
  children: [
    {
      path: '',
      name: 'dominaFormsDashboard',
      component: () => import('modules/dominaForm/pages/Dashboard.vue')
    },
    {
      path: 'candidate',
      name: 'dominaFormsCandidate',
      component: () => import('modules/dominaForm/pages/Employee.vue')
    },
    {
      path: 'employee',
      name: 'dominaFormsEmployee',
      component: () => import('modules/dominaForm/pages/Employee.vue')
    },
    {
      path: 'employer',
      name: 'dominaFormsEmployer',
      component: () => import('modules/dominaForm/pages/Employer.vue')
    },
    {
      path: 'recruit',
      name: 'dominaFormsRecruit',
      component: () => import('modules/dominaForm/pages/Recruit.vue')
    },
    {
      path: 'contract',
      name: 'dominaFormsContract',
      component: () => import('modules/dominaForm/pages/Contract.vue')
    },
    {
      path: 'settings',
      name: 'dominaFormsSettings',
      component: () => import('modules/dominaForm/pages/Settings.vue')
    }
  ]
}

export default formRoutes